<template>
<div class="quiz-question text-left">
  <div class="question-title text-center">
    <h3 class="title">
      <span v-if="quiz.questionCommonPartPre"
            class="title__pre">{{ quiz.questionCommonPartPre }}</span>
      <span class="title__text">
        {{ question.title }}
      </span>
      <span v-if="quiz.questionCommonPartPost"
            class="title__post">{{ quiz.questionCommonPartPost }}</span>
    </h3>
    <div class="text-italic question-hint" v-show="question.kind === 'single'">
      {{ $t('choose_the_most_appropriate') }}
    </div>
    <div class="text-italic question-hint" v-if="question.kind === 'multiple'">
      {{ $t('choose_all_matching_answers') }}
    </div>
    <div class="text-italic question-hint" v-if="question.kind === 'text'">
      {{ $t('type_in_the_answer') }}
    </div>
  </div>

  <div class="code code-block" v-show="question.code_block">
    <code v-html="code_block_text">
    </code>
  </div>

  <single-question
      :question.sync="question"
      :resolve="resolve"
      :sendAnswer="answer"
      v-if="question.kind === 'single'">
  </single-question>

  <multiple-question
      :question.sync="question"
      :resolve="resolve"
      :sendAnswer="answer"
      v-if="question.kind === 'multiple'">
  </multiple-question>

  <text-question
      :question.sync="question"
      :resolve="resolve"
      :sendAnswer="answer"
      v-if="question.kind === 'text'">
  </text-question>

</div>
</template>

<script>
import SingleQuestion from './questions/SingleQuestion';
import MultipleQuestion from './questions/MultipleQuestion';
import TextQuestion from './questions/TextQuestion';

export default {
  name: 'Question',
  components: {
    TextQuestion,
    MultipleQuestion,
    SingleQuestion,
  },
  data() {
    return {
      quiz: window.Quiz,
    };
  },
  props: ['question', 'resolve'],
  computed: {
    code_block_text() {
      // Hacky new line to br stuff, TODO improve parsing
      if (!this.question || !this.question.code_block) {
        return '';
      }

      // eslint-disable-next-line
      return this.question.code_block.replace(new RegExp('\r?\n', 'g'), '<br />');
    },
  },
  methods: {
    answer(val) {
      this.$emit('answer', val);
    },
  },
};
</script>

<style scoped>
.quiz-question {
  margin-top: 1.5em;
}

.code-block {
  margin-bottom: 15px;
}

.question-title {
  margin: 20px auto 30px;
  /*width: 80%;*/
}
.question-title .title {
  /*min-height: 3.8em;*/
  display: block;
  font-size: 32px;
  font-weight: 700;
  margin-bottom: .5em;
}
.title__pre {
  margin-bottom: .2em;
  width: 100%;
  display: block;
  font-size: .8em;
  color: #443899;
}
.title__text {
  color: var(--color-system-accent)
}

.question-hint {
  font-size: 0.7em;
  opacity: .6;
}
</style>
